export const logError = (error: any, type: string) => {
  console.error(`${type}\n${error}`);
};
